import { PlanAsset } from 'api-validations/locutus'
import type { FC } from 'react'
import { Icon } from 'shared-ui/components'
import { SpriteMap } from 'shared-ui/global'
import { createVariants } from 'shared-ui/lib'

import type { UploadAssetType } from '../../lib/planUpload/planEntry'

const icons = {
  [PlanAsset.Boundary]: SpriteMap.FieldBoundariesIcon,
  [PlanAsset.Prescription]: SpriteMap.PrescriptionIcon
} as const satisfies Record<UploadAssetType, SpriteMap>

const iconClasses = createVariants({
  base: 'flex h-full items-center rounded-l-2xl px-2',
  variants: {
    asset: {
      [PlanAsset.Boundary]: 'bg-purple-200 text-purple-600',
      [PlanAsset.Prescription]: 'bg-pink-300 text-pink-700'
    }
  }
})

const textClasses = createVariants({
  base: 'pan-body-small flex h-full items-center whitespace-nowrap rounded-r-2xl pl-2 pr-3',
  variants: {
    asset: {
      [PlanAsset.Boundary]: 'bg-purple-100 text-purple-600',
      [PlanAsset.Prescription]: 'bg-pink-200 text-pink-700'
    }
  }
})

export const PlanAssetChip: FC<{ asset: UploadAssetType; text: string }> = ({ asset, text }) => (
  <span className="flex h-6 shrink-0 items-center">
    <span className={iconClasses({ asset })}>
      <Icon icon={icons[asset]} className="size-4" />
    </span>
    <span className={textClasses({ asset })}>{text}</span>
  </span>
)
